var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-info" }, [
      _c("div", { staticClass: "form-row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.voucher.deliverFinished
            ? _c("div", { staticClass: "value" }, [_vm._v("是")])
            : _c("div", { staticClass: "value" }, [_vm._v("否")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.voucher.fullfilled
            ? _c("div", { staticClass: "value" }, [_vm._v("是")])
            : _c("div", { staticClass: "value" }, [_vm._v("否")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.voucher.checked
            ? _c("div", { staticClass: "value" }, [_vm._v("是")])
            : _c("div", { staticClass: "value" }, [_vm._v("否")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.voucher.closed
            ? _c("div", { staticClass: "value" }, [_vm._v("是")])
            : _c("div", { staticClass: "value" }, [_vm._v("否")])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("交付是否完成")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("履约是否完成")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("验收是否完成")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否关闭")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cce3ab9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cce3ab9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/tradeVoucher/TradeVoucherDeliverInfo.vue
// module id = 1851
// module chunks = 1